import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { OnBoardingType, OnBoardingVideoType } from '@app/entities/interfaces/user/user-onboarding.interface';
import { OnBoardingVideo } from '@app/entities/models/on-boarding-video/on-boarding-video.model';

export interface OnBoardingVideoUseCases {
  getOnBoardingVideo(
    companyCode: string,
    type: OnBoardingType,
    videoType: OnBoardingVideoType
  ): Observable<OnBoardingVideo[]>;
}

export const ON_BOARDING_VIDEO_USE_CASES = new InjectionToken<OnBoardingVideoUseCases>('ON_BOARDING_VIDEO_USE_CASES');
